export interface DisclaimerBadgeConfig {
	label: string;
	classes: string;
}

type DisclaimerStatus = "no_conflict" | "conflict" | "reviewed" | null | undefined;
type DisclaimerReviewAction = "accepted" | "revoked" | null | undefined;

export const getDisclaimerBadge = (
	status: DisclaimerStatus,
	reviewAction?: DisclaimerReviewAction
): DisclaimerBadgeConfig => {
	switch (status) {
		case "no_conflict":
			return { label: "No Conflict", classes: "bg-green-100 text-green-700" };
		case "conflict":
			return { label: "Conflict", classes: "bg-red-100 text-red-700" };
		case "reviewed":
			if (reviewAction === "revoked") {
				return { label: "Revoked", classes: "bg-red-100 text-red-700" };
			}
			return { label: "Reviewed", classes: "bg-green-100 text-green-700" };
		default:
			return { label: "Pending", classes: "bg-gray-100 text-gray-600" };
	}
};
